'use client';

import { c as _c } from "react/compiler-runtime";
import type { ScrollableElement } from 'src/types/scrollbars';
import type { CollapseProps as MuiCollapseProps } from '@mui/material/Collapse';
import type React from 'react';
import Collapse from '@mui/material/Collapse';
import { default as MuiList } from '@mui/material/List';
import { styled } from '@mui/material/styles';
import { shouldForwardProp } from 'src/components/Particles/Particles';
import { scrollbarCustomProps, scrollbarMixin, isScrollbarDisabled, isWithScroll, isVertical } from 'src/components/Particles/Scrollbars';
interface CustomListProps {
  className?: string;
  children: React.ReactNode;
  isClosed?: boolean;
}
type CollapseProps = MuiCollapseProps & ScrollableElement & {
  className?: string;
};
type ListProps = CustomListProps & ScrollableElement;
const StyledCollapse = styled(Collapse, {
  ...shouldForwardProp(scrollbarCustomProps)
})<CollapseProps>(props => ({
  ...scrollbarMixin(props),
  margin: `${props.theme.sizes.spacing['04']} 0`,
  '&.rootList': {
    paddingBottom: '3rem'
  }
}));

// const StyledCollapse = styled(Collapse)<CollapseProps>();

const StyledList = styled(MuiList, {
  ...shouldForwardProp(scrollbarCustomProps)
})(({
  theme
}) => ({
  flexGrow: 1,
  padding: `0 ${theme.sizes.spacing['04']}`,
  // gap: theme.sizes.spacing['02'],
  display: 'flex',
  flexDirection: 'column'
}));
const List: React.FC<ListProps> = t0 => {
  const $ = _c(15);
  let children;
  let isClosed;
  let props;
  let scrollProps;
  if ($[0] !== t0) {
    const {
      children: t1,
      isClosed: t2,
      ...t3
    } = t0;
    children = t1;
    props = t3;
    isClosed = t2 === undefined ? false : t2;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {};
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    scrollProps = t4;
    if (!isScrollbarDisabled(props)) {
      if (isWithScroll(props) === true && isVertical(props) === true) {
        let t5;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = {
            withScroll: true,
            vertical: true
          };
          $[6] = t5;
        } else {
          t5 = $[6];
        }
        scrollProps = t5;
      }
    }
    $[0] = t0;
    $[1] = children;
    $[2] = isClosed;
    $[3] = props;
    $[4] = scrollProps;
  } else {
    children = $[1];
    isClosed = $[2];
    props = $[3];
    scrollProps = $[4];
  }
  const t1 = !isClosed;
  let t2;
  if ($[7] !== children || $[8] !== props) {
    t2 = <StyledList {...props}>{children}</StyledList>;
    $[7] = children;
    $[8] = props;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== props.className || $[11] !== scrollProps || $[12] !== t1 || $[13] !== t2) {
    t3 = <StyledCollapse in={t1} timeout="auto" {...scrollProps} className={props.className} unmountOnExit={true}>{t2}</StyledCollapse>;
    $[10] = props.className;
    $[11] = scrollProps;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default List;
export type { ListProps };